module.exports = __webpack_public_path__ + "static/media/captainK.9c633438.svg";